// Copyright 2016 Sorama B.V.

import { CreditsDebetAction } from "datatypes/CreditsMutation";
import { IIndexableObject } from "libraries/IndexedDb/IIndexableObject";

export class PendingCreditsTransaction implements IIndexableObject {
    /* Unique identifier for specified object.*/
    id: string;

    /* String defining the user of the Object */
    userId: string;

    /* Pending Transaction */
    pendingTransaction: CreditsDebetAction;
}
